import { TokenData } from '../_interfaces/session.model';

export const EMPTY_TOKEN_DATA: TokenData = {
  tokenType: '',
  accessToken: '',
  expiresIn: 0,
  refreshToken: '',
};
